<template>
  <div class="project">
    <div class="p-header">
      <!-- 返回 -->
      <span class="backbtn" @click="goback">
        <i class="iconfont icon-fanhui1"></i>
        <span>{{ $t('project.back') }}</span>
      </span>
      <span class="p-line">|</span>
      <!-- 项目管理 -->
      <span class="p-label">{{ $t('project.manageProject') }}</span>
    </div>
    <div class="p-main">
      <!-- 项目列表 -->
      <div class="p-sidebar">
        <template v-for="(item) in proList">
          <!-- :class="{'p-name-default': item.pid == '253964'}" -->
          <button class="p-name" :key="item.pid" :class="{ 'activePro': item.pid == proCurrentPid }"
            @click="getProjectDeviceList({ 'plantid': item.pid })">
            <!-- 名称 -->
            <span class="pnamebox">
              <span class="pname">{{ item.pname }}</span>
            </span>
            <!-- 计数 -->
            <!-- {{`(${item.device.length}/50)`}} -->
            <span class>
              <!-- {{`(${item.device.length}/50)`}} -->
              <!-- {{`(${item.pid == proCurrentPid ? deviceList.length : 0}/50)`}} -->
              <!-- number/total -->
              <!-- 计数暂时注释 -->
              <!-- {{`(${item.number ? item.number : ''}/50)`}} -->
            </span>
            <!-- 默认标识 -->
            <!-- <span class="p-name-sign" v-if="item.pid == '253964'">
              <span class="p-name-text">{{$t('device.default')}}</span>
            </span>-->
            <!-- 项目操作 -->
            <span class="p-operatebox" @click.stop>
              <span class="p-operate">
                <!-- 编辑项目 -->
                <i class="ico ico-edit" @click.stop="editProject(item)"></i>
                <!-- 删除项目 -->
                <!-- v-if="item.pid != '253964'" -->
                <i style="margin-left:10px;" class="ico ico-del" @click.stop="delProject(item)"></i>
              </span>
            </span>
          </button>
        </template>
        <!-- 新建项目 -->
        <button class="p-create" @click="createProject">
          <i class="ico-create"></i>
          <span>{{ $t('project.createProject') }}</span>
        </button>
      </div>
      <!-- 对应设备列表 -->
      <div class="p-panel">
        <!-- 加入Tab切换 -->
        <!-- @tab-click="handleClick" -->
        <el-tabs v-model="activeName" class="rightTab" v-if="$store.state.device.isShow == 1">
          <!-- Tab-设备列表开始 -->
          <el-tab-pane :label="$t('device.deviceList')" name="ptabsn" class="section">
            <!-- <div class="section"> -->
            <!-- <div > -->
              <!-- 筛选 -->
              <div class="search">
                <!-- {{$t('datalogger.Datalogger_Status')+'：'}} -->
                <div>
                  <span class="search-label">{{ $t('device.device_status') }}</span>
                  <el-select v-model="search.status" @change="getDeviceList" :placeholder="$t('header.pleaseSelect')"
                    popper-class="select-search-recharge" class="selectClearNew" clearable>
                    <el-option v-for="(value, key) in $filter.deviceStatus" :key="key" :value="key" :label="value.label"
                      style="display:flex;align-items:center;">
                      <!-- :class="item.class" -->
                      <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${value.name}`"></i>
                      <span class="select-label">{{ value.label }}</span>
                    </el-option>
                  </el-select>
                </div>


                <!-- 搜索 -->
                <!-- showSearch = true; -->
                <el-button class="button button-solid" @click.stop="showSearchBtn">
                  <i class="el-icon-search"></i>
                </el-button>
                <div class="search-alert" v-show="showSearch" @click.stop>
                  <!-- @input实时、 @keyup.enter.native回车 -->
                  <el-input ref="iptFocus" v-model.trim="search.pn" @keyup.enter.native="getDeviceList(true)"
                    :placeholder="this.$t('device.device_pn')" clearable>
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <!-- 取消 -->
                  <span class="search-hide" @click.stop="closeSearch">{{ $t('rate.cancel') }}</span>
                </div>
                <!-- 导出 -->
                <!-- <button
                style="float: right;margin-right:10px;"
                class="button"
                :class="pagination.total ? 'button-solid' : 'button-disable'"
                @click="exportPlant('all')"
                >{{$t('report.all_reports')}}</button>-->
                <!-- <button
                style="float: right;margin-right:10px;"
                :class="selectedplant.length ? 'button-solid' : 'button-disable'"
                @click="exportPlant(selectedplant)"
                >{{$t('report.Batch_export')}}</button>-->

                <!-- 批量操作弹条 (显隐由是否勾选决定) -->
                <!-- v-show="selectedDevice.length" -->
                <!-- v-show="false" -->
                <!-- 批量删除设备(暂时注释，接口待开发) -->
                <div class="batch-alert" v-show="false">
                  <!-- 当前选中条数 -->
                  <span class="batch-total">{{ `${$t('alarm.curSelected')} ${selectedDevice.length}
                                    ${$t('alarm._Data')}` }}</span>
                  <div class="batch-right">
                    <!-- 操作 -->
                    <span class="batch-operate">
                      <!-- 导出 -->
                      <!-- <span 
                      class="btn"
                      @click="exportPlant(selectedDevice)"
                    >
                      {{$t('report.Export')}}
                      <i class="ico ico-export"></i>
                      </span>-->
                      <!-- 删除 -->
                      <span class="btn" @click="deleteDevice(selectedDevice)">
                        {{ $t('device.delete') }}
                        <i class="ico ico-clear"></i>
                      </span>
                    </span>
                    <!-- 取消 -->
                    <span class="batch-hide" @click="closeBatch">{{ $t('rate.cancel') }}</span>
                  </div>
                </div>
              </div>
              <!-- 设备列表 -->
              <el-table :data="deviceList" border stripe height="100%" :row-style="{ height: 0 }"
                :cell-style="{ padding: 0 }" :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
                v-loading="loadingdevice" element-loading-spinner="el-icon-loading" @selection-change="changeFun"
                class="tablemain tableloding" :empty-text="$t('account.nodata')" ref="multipleSnTable">
                <!-- 批量设备操作(暂时注释，接口待开发) -->
                <!-- <el-table-column fixed type="selection"></el-table-column> -->
                <!-- 别名 -->
                <el-table-column fixed prop="devalias" min-width="185px;" :label="$t('device.device_name')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span class="redirect" @click="enterDevice(scope.row)" :title="scope.row.devalias || scope.row.sn">{{
                      scope.row.devalias || scope.row.sn }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                prop="devalias"
                min-width="185px;"
                :label="$t('device.device_name')"
                :show-overflow-tooltip="true"
                ></el-table-column>-->
                <!-- sn -->
                <el-table-column prop="sn" min-width="185px;" :label="$t('device.device_sn')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">{{ scope.row.deviceSn || scope.row.sn }}</template>
                </el-table-column>
                <!-- 状态 -->
                <el-table-column prop="status" min-width="120px;" :label="$t('device.device_status')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status !== undefined"
                      :class="`color-${$filter.deviceStatus[scope.row.status].name}`">{{
                        $filter.deviceStatus[scope.row.status].label }}</span>
                  </template>
                </el-table-column>
                <!-- 设备类型 -->
                <el-table-column prop="brand" min-width="115px;" :label="$t('device.device_type')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">{{ scope.row.brand | translateDeviceType }}</template>
                </el-table-column>
                <!-- 通讯协议 -->
                <el-table-column width="90px;" prop="devcode" :label="$t('device.device_code')"
                  :show-overflow-tooltip="true"></el-table-column>-->
                <!-- pn -->
                <el-table-column prop="pn" min-width="140px;" :label="$t('device.datalogger_pn')"
                  :show-overflow-tooltip="true"></el-table-column>
                <!-- 地址 -->
                <el-table-column prop="devaddr" min-width="135px;" :label="$t('device.device_address')"
                  :show-overflow-tooltip="true"></el-table-column>
                <!-- 今日收益 -->
                <el-table-column prop="profitToday" min-width="120px;" :label="$t('device.Today_income')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.profitToday | formatNum(2) }}</span>
                  </template>
                </el-table-column>
                <!-- 总收益 -->
                <el-table-column prop="profitTotal" min-width="150px;" :label="$t('device.Cumulative_income')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ scope.row.profitTotal | formatNum(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="sellProfitToday" min-width="150px;" :label="$t('device.sellProfit_Today')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{scope.row.sellProfitToday | formatNum(2)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="sellProfitTotal" min-width="150px;" :label="$t('device.sellProfit_Total')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{scope.row.sellProfitTotal | formatNum(2)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="buyProfitToday" min-width="150px;" :label="$t('device.buyProfit_Today')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{scope.row.buyProfitToday | formatNum(2)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="buyProfitTotal" min-width="150px;" :label="$t('device.buyProfit_Total')"
                  :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{scope.row.buyProfitTotal | formatNum(2)}}</span>
                  </template>
                </el-table-column>
                <!-- 数采器 -->
                <el-table-column prop="collalias" min-width="140px;" :label="$t('device.coll_alias')"
                  :show-overflow-tooltip="true"></el-table-column>
                <!-- 设备型号 -->
                <el-table-column width="115px;" :label="$t('device.device_model')" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span :title="scope.row.devtype || '--'">{{ scope.row.devtype || '--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="this.$t('device.Operation')" width="240" fixed="right">
                  <template slot-scope="scope">
                    <!-- 编辑 -->
                    <el-button type="text" class="operation" :title="$t('device.edit')" @click="editDevice(scope.row)">
                      <i class="iconfont icon-bianji"></i>
                    </el-button>
                    <el-button type="text" class="operation" :title="$t('device.debug')" @click="debugDevice(scope.row)">
                      <i class="iconfont icon-tiaoshi1"></i>
                    </el-button>
                    <el-button type="text" class="operation" :title="$t('device.control')"
                      @click="controlDevice(scope.row)">
                      <i class="iconfont icon-caozuo_kongzhi"></i>
                    </el-button>
                    <el-button type="text" class="operation" :title="$t('device.upgrade1')"
                      @click="upgradeDevice(scope.row)">
                      <i class="iconfont icon-caozuo_shengji"></i>
                    </el-button>
                    <el-button type="text" class="operation" :title="$t('report.Export_report')"
                      @click="exportPlant([scope.row])">
                      <i class="iconfont icon-baobiao"></i>
                    </el-button>
                    <el-button type="text" class="operation" :title="$t('device.delete')" @click="deleteDevice(scope.row)">
                      <i class="iconfont icon-caozuo_shanchu"></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="tablebottom">
                <!-- 批量占位 -->
                <div class style="margin-left:10px;">
                  <!-- 批量导出 -->
                  <!-- <button
                  style="height:32px;"
                  class="btn"
                  :class="selectedDevice.length ? 'btn-dark' : 'btn-disable'"
                  @click="exportPlant(selectedDevice)"
                  >{{$t('report.Batch_export')}}</button>-->
                  <!-- 批量删除 -->
                  <!-- <button
                  style="height:32px;margin-left:10px;"
                  class="btn"
                  :class="selectedDevice.length ? 'btn-dark' : 'btn-disable'"
                  @click="deleteDevice(selectedDevice)"
                  >{{$t('alarm.Delete_selected')}}</button>-->
                </div>
                <!-- 分页 -->
                <el-pagination class="pagination" background @size-change="getDeviceList(true)"
                  @current-change="() => getDeviceList()" :current-page.sync="pagination.currentPage"
                  :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
                  layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total"
                  popper-class="select-page">
                  <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
                </el-pagination>
              </div>
            <!-- </div> -->
            
            <!-- </div> -->
          </el-tab-pane>
          <!-- Tab-设备列表结束 -->

          <!-- 数采器列表(抽离) -->
          <el-tab-pane :label="$t('device.dataloggerList')" name="ptabpn" class="section">
            <tab-datalogger :proCurrentPid="proCurrentPid" :proList="proList"></tab-datalogger>
          </el-tab-pane>
        </el-tabs>
        <div v-if="$store.state.device.isShow == 3" class="debugInfo">
          <div class="deviceHeader">
            <div class="deviceHeaderLeft">
              <div class="closepage" @click="goList"></div>
              <div>{{ `${$t('device.deviceDebug')}` }}</div>
            </div>
          </div>
          <div class="deviceBody">
            <el-form class="grid">
              <el-form-item :label="$t('datalogger.datalogger_pn')" size="small">
                <div>{{ deviceInfo.pn }}</div>
              </el-form-item>
              <el-form-item :label="$t('datalogger.communication_address')" size="small">
                <el-input :disabled="true" class="devaddrClass" type="number" v-model="deviceInfo.devaddr" auto-complete="off"  oninput="if(value<1)value=1;if(value>255)value=255"></el-input>
              </el-form-item>
              <el-form-item :label="$t('datalogger.Instruction')" size="small">
                <el-input :rows="4" v-model="devDebug.cmd" :placeholder="$t('datalogger.such_as')" type="textarea"
                  auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label=" ">
                <div style="text-align:right;">
                  <button type="button" class="btn btn-dark" @click="submitDebugDevice()">{{ $t('datalogger.send')}}</button>
                </div>
              </el-form-item>
              <el-form-item :label="$t('datalogger.return_content')" size="small">
                <div class="debug-return">
                  <div class="return-tool">
                    <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                      data-clipboard-target="#link">
                      <i class="ico ico-copy"></i>
                      {{ $t('device.copy_val') }}
                    </span>
                    <span class="btn" @click="qingkong()">
                      <i class="ico ico-clear"></i>
                      {{ $t('device.clear_val') }}
                    </span>
                  </div>
                  <el-input :rows="10" readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="$store.state.device.isShow == 2" class="debugInfo">
          <div class="deviceHeader">
            <div class="deviceHeaderLeft">
              <div class="closepage" @click="goList"></div>
              <div>{{ `${$t('datalogger.datalogger_debug')}` }}</div>
            </div>
          </div>
          <div class="deviceBody">
            <el-form class="grid">
              <el-form-item :label="$t('datalogger.datalogger_pn')" size="small">
                <div>{{ deviceInfo.pn }}</div>
              </el-form-item>
              <el-form-item :label="$t('datalogger.communication_address')" size="small">
                <el-input class="devaddrClass" type="number" v-model="datalogger.devaddr" auto-complete="off"  oninput="if(value<1)value=1;if(value>255)value=255"></el-input>
              </el-form-item>
              <el-form-item :label="$t('datalogger.Instruction')" size="small">
                <el-input :rows="4" v-model="devDebug.cmd" :placeholder="$t('datalogger.such_as')" type="textarea"
                  auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label=" ">
                <div style="text-align:right;">
                  <button type="button" class="btn btn-dark" @click="submitDebugDatalogger()">{{ $t('datalogger.send')}}</button>
                </div>
              </el-form-item>
              <el-form-item :label="$t('datalogger.return_content')" size="small">
                <div class="debug-return">
                  <div class="return-tool">
                    <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                      data-clipboard-target="#link">
                      <i class="ico ico-copy"></i>
                      {{ $t('device.copy_val') }}
                    </span>
                    <span class="btn" @click="qingkong()">
                      <i class="ico ico-clear"></i>
                      {{ $t('device.clear_val') }}
                    </span>
                  </div>
                  <el-input :rows="10" readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- ==========设备相关弹窗开始========== -->
        <!-- 新建项目 -->
        <!-- v-if="createProjectVisible" -->
        <device-dialog :title="$t('project.createProject')" :visible.sync="createProjectVisible"
          :class="{ 'showDialog': createProjectVisible, 'hideDialog': !createProjectVisible }" noFooter>
          <div slot="content">
            <el-form slot="content" class="grid" :rules="formDataRules" :model="pFormData" ref="pFormDataAdd">
              <!-- 项目名称 -->
              <el-form-item  prop="name" :label="`${$t('project.projectName')}:`" size="small">
                <el-input v-model="pFormData.name" clearable></el-input>
              </el-form-item>
              <!-- 项目描述 -->
              <el-form-item :label="`${$t('project.projectRemark')}:`" size="small">
                <el-input v-model="pFormData.remark" clearable></el-input>
              </el-form-item>
              <!-- 上传图片 -->
              <!-- <el-form-item label=" " prop="picSmall">
                <div style="text-align:center;">
                  <img :src="pFormData.picSmall ? pFormData.picProjectPic : ''" />
                </div>
                <div class="upload-contents" v-if="upbtnVisible">
                  <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                    <i class="iconfont icon-shangchuan1"></i>
                  </button>
                  <div class="upload-tip">{{ `${$t('project.upload')} (${$t('project.limit')})` }}</div>
                  <input type="file" class="upload-input" ref="fileUploader" accept="image/jpeg, image/png"
                    @change="uploadImage($event)" />
                </div>
              </el-form-item> -->
            </el-form>
            <div style="text-align:right;">
              <button class="btn btn-dark" @click="submitCreateProject">{{ $t('device.confirm') }}</button>
            </div>
          </div>
        </device-dialog>
        <!-- 新建项目结果提示(成功) -->
        <!-- v-if="createProjectSucVisible" -->
        <device-dialog :title="$t('project.createResults')" :visible.sync="createProjectSucVisible"
          :class="{ 'showDialog': createProjectSucVisible, 'hideDialog': !createProjectSucVisible }" width="500px"
          noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t('project.createSuc') }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="createProjectSucVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 新建项目结果提示(失败) -->
        <!-- v-if="createProjectFailVisible" -->
        <device-dialog :title="$t('project.createResults')" :visible.sync="createProjectFailVisible"
          :class="{ 'showDialog': createProjectFailVisible, 'hideDialog': !createProjectFailVisible }" width="500px"
          noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="createProjectFailVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>

        <!-- 编辑项目 -->
        <!-- v-if="editProjectVisible" -->
        <device-dialog :title="$t('project.editProject')" :visible.sync="editProjectVisible"
          :class="{ 'showDialog': editProjectVisible, 'hideDialog': !editProjectVisible }" noFooter>
          <div slot="content">
            <el-form class="grid" :rules="formDataRules" :model="pFormData" ref="pFormDataEdit">
              <!-- 项目名称 -->
              <el-form-item :label="$t('project.projectName')" prop="name" size="small">
                <el-input v-model="pFormData.name"></el-input>
              </el-form-item>
              <!-- 项目描述 -->
              <el-form-item :label="`${$t('project.projectRemark')}:`" prop="remark" size="small">
                <el-input v-model="pFormData.remark" clearable></el-input>
              </el-form-item>
              <!-- 上传图片 -->
              <!-- <el-form-item label=" " prop="picSmall">
                <div style="text-align:center;">
                  <img :src="pFormData.picSmall ? pFormData.picProjectPic : ''" />
                </div>
                <div class="upload-contents" v-if="upbtnVisible">
                  <button type="button" class="upload-buttonEquipment" @click="$refs.fileUploader.click()">
                    <i class="iconfont icon-shangchuan1"></i>
                  </button>
                  <div class="upload-tip">{{ `${$t('project.upload')} (${$t('project.limit')})` }}</div>
                  <input type="file" class="upload-input" ref="fileUploader" accept="image/jpeg, image/png"
                    @change="uploadImage($event)" />
                </div>
              </el-form-item> -->
            </el-form>
            <div style="text-align:right;">
              <button class="btn btn-dark" @click="submitEditProject">{{ $t('device.confirm') }}</button>
            </div>
          </div>
        </device-dialog>
        <!-- 编辑项目结果提示(成功) -->
        <!-- v-if="editProjectSucVisible" -->
        <device-dialog :title="$t('project.editResults')" :visible.sync="editProjectSucVisible"
          :class="{ 'showDialog': editProjectSucVisible, 'hideDialog': !editProjectSucVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t('project.editSuc') }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="editProjectSucVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 编辑项目结果提示(失败) -->
        <!-- v-if="editProjectFailVisible" -->
        <device-dialog :title="$t('project.editResults')" :visible.sync="editProjectFailVisible"
          :class="{ 'showDialog': editProjectFailVisible, 'hideDialog': !editProjectFailVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="editProjectFailVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>

        <!-- 删除项目 -->
        <!-- v-if="deletingProjectInfo" -->
        <device-dialog :title="$t('project.delProject')" :visible.sync="deletingProjectInfo"
          :class="{ 'showDialog': deletingProjectInfo, 'hideDialog': !deletingProjectInfo }" width="30vw" noFooter>
          <div class="content_tishi" slot="content">
            <div class="tital">
              <!-- <i class="iconfont icon-gantanhao"></i> -->
              <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('device.confirm_deldte') }}</span>
            </div>
            <div class="disabledescr">
              <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('account.notRecovered') }}</span>
            </div>
            <div class="deletfotter" style="text-align:right;margin-top:28px;">
              <button class="btn btn-dark" style="margin-right:10px;" @click="submitDelProject">{{ $t('device.confirm')
              }}</button>
              <button class="btn btn-light" @click="deletingProjectInfo = null">{{ $t('device.cancel') }}</button>
            </div>
          </div>
        </device-dialog>
        <!-- 删除项目结果提示(成功) -->
        <!-- v-if="delProjectSucVisible" -->
        <device-dialog :title="$t('project.delResults')" :visible.sync="delProjectSucVisible"
          :class="{ 'showDialog': delProjectSucVisible, 'hideDialog': !delProjectSucVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t('project.delSuc') }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="delProjectSucVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 删除项目结果提示(失败) -->
        <!-- v-if="delProjectFailVisible" -->
        <device-dialog :title="$t('project.delResults')" :visible.sync="delProjectFailVisible"
          :class="{ 'showDialog': delProjectFailVisible, 'hideDialog': !delProjectFailVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="delProjectFailVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>

        <!-- 编辑设备 -->
        <!-- v-if="editDeviceVisible" -->
        <device-dialog :title="$t('device.modify_alias')" :visible.sync="editDeviceVisible"
          :class="{ 'showDialog': editDeviceVisible, 'hideDialog': !editDeviceVisible }" noFooter>
          <div slot="content">
            <el-form class="grid">
              <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
                <el-input :value="formEdit.deviceSn || formEdit.sn" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('device.device_code_form')" prop="devcode" size="small">
                <el-input v-model="formEdit.devcode" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
                <el-input v-model="formEdit.devalias" clearable></el-input>
              </el-form-item>
            </el-form>
            <div style="text-align:right;">
              <button type="button" class="btn btn-dark" @click="submitEditDevice">{{ $t('device.confirm') }}</button>
              <button type="button" class="btn btn-light" style="margin-left: 10px;" @click="editDeviceVisible = false">{{
                $t('device.cancel') }}</button>
            </div>
          </div>
          <div slot="footer">
            <!-- <button class="button-hollow" @click="editDeviceVisible = false">{{$t('device.cancel')}}</button> -->
            <!-- <button class="button-solid" @click="submitEditDevice">{{$t('device.confirm')}}</button> -->
          </div>
        </device-dialog>
        <!-- 修改设备结果提示(成功) -->
        <!-- v-if="editDeviceSucVisible" -->
        <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceSucVisible"
          :class="{ 'showDialog': editDeviceSucVisible, 'hideDialog': !editDeviceSucVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t('project.editSuc') }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button type="button" class="btn btn-dark" @click="editDeviceSucVisible = false;">{{
                  $t('datalogger.confirm') }}</button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 修改设备结果提示(失败) -->
        <!-- v-if="editDeviceFailVisible" -->
        <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceFailVisible"
          :class="{ 'showDialog': editDeviceFailVisible, 'hideDialog': !editDeviceFailVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button type="button" class="btn btn-dark" @click="editDeviceFailVisible = false;">{{
                  $t('datalogger.confirm') }}</button>
              </div>
            </div>
          </div>
        </device-dialog>

        <!-- 逆变器调试 -->
        <!-- v-if="debugDeviceVisible" -->
        <device-dialog :title="$t('device.debug')" :visible.sync="debugDeviceVisible"
          :class="{ 'showDialog': debugDeviceVisible, 'hideDialog': !debugDeviceVisible }" noFooter>
          <div slot="content">
            <el-form slot="content" class="grid">
              <el-form-item :label="$t('device.Device_pn')" size="small">
                <el-input v-model="device.pn" auto-complete="off" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('device.Instruction')" size="small">
                <el-input v-model="devDebug.cmd" :placeholder="$t('device.such_as')" type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }" auto-complete="off"></el-input>
              </el-form-item>
              <!-- 发送指令 -->
              <el-form-item label=" ">
                <div style="text-align:right;">
                  <button class="btn btn-dark" type="button" @click="submitDebugDevice()">{{ $t('device.send') }}</button>
                </div>
              </el-form-item>
              <el-form-item :label="$t('device.return_content')" size="small">
                <div class="debug-return">
                  <!-- id="link" -->
                  <el-input readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
                  <div class="return-tool">
                    <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                      data-clipboard-target="#link">
                      <i class="ico ico-copy"></i>
                      {{ $t('device.copy_val') }}
                    </span>
                    <span class="btn" @click="qingkong()">
                      <i class="ico ico-clear"></i>
                      {{ $t('device.clear_val') }}
                    </span>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer">
            <!-- <button 
              class="button-hollow" 
              @click="qingkong()"
            >{{$t('device.clear_data')}}</button>-->
            <!-- <button
              class="button-solid"
              type="primary"
              @click="submitDebugDevice()"
            >{{$t('device.send')}}</button>-->
          </div>
        </device-dialog>

        <!-- 控制项 -->
        <!-- v-if="controlDeviceVisible" -->
        <device-dialog :title="$t('device.control')" :width="'1000px'"
          :class="{ 'showDialog': controlDeviceVisible, 'hideDialog': !controlDeviceVisible }"
          :visible.sync="controlDeviceVisible" noFooter>
          <div @click="clickClosePicker()" class="control" slot="content">
          <div v-if="tableDataBse.length">
            <div class="tableTitle">{{ $t('createPlant.basic_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBse" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataStd.length">
            <div class="tableTitle">{{ $t('createPlant.Standard_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataStd" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataSvs.length">
            <div class="tableTitle">{{ $t('createPlant.System_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataSvs" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataPvs.length">
            <div class="tableTitle">{{ $t('createPlant.Solar_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataPvs" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')" style="background-color: #fff;">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataGrd.length">
            <div class="tableTitle">{{ $t('createPlant.Grid_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataGrd" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')" style="padding: 0;">
                <template slot-scope="scope">
                  <div style="padding: 0;" class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="tableDataBat.length">
            <div class="tableTitle">{{ $t('createPlant.Battery_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBat" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataCts.length">
            <div class="tableTitle">{{ $t('createPlant.Control_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataCts" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataLos.length">
            <div class="tableTitle">{{ $t('createPlant.Load_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataLos" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataBas.length">
            <div class="tableTitle">{{ $t('createPlant.Basic_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataBas" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataAdv.length">
            <div class="tableTitle">{{ $t('createPlant.Advanced_setting') }}</div>
            <el-table class="tableBackgruond" :data="tableDataAdv" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataElse.length">
            <div class="tableTitle">{{ $t('createPlant.other_settings') }}</div>
            <el-table class="tableBackgruond" :data="tableDataElse" stripe border :empty-text="$t('message.nodata')" :cell-style="OperationStyle">
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="250px"></el-table-column>
              <el-table-column prop="unit" width="150px" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')" min-width="160px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                    popper-class="select-search-recharge">
                    <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <div @click.stop v-else-if="scope.row.id === 'system_time' || scope.row.id === 'sys_system_time'">
                    <el-date-picker  v-model="scope.row.controlvalue" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
                      :append-to-body="false"
                       type="datetime"
                      :ref="`controlDatepickerRef-${scope.row.id}`" popper-class="select-date" :placeholder="'yyyy-MM-dd HH:mm:ss'">
                    </el-date-picker>
                  </div>
                  <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"></el-input>
                  <el-input v-model="scope.row.controlvalue" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column width="200px" :label="$t('device.Operation')">
                <template slot-scope="scope">
                  <div class="instructieClass">
                    <el-button v-loading="scope.row.isLoading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="huoquInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-shuaxin"></i>
                      <span>{{$t('device.read') }}</span>
                    </el-button>
                    <el-button v-loading="scope.row.Loading" style="color:#fff;background-color: rgba(23, 194, 133, 0.5);" @click="xiafaInverter(scope.row)" class="submit-control btn btn-dark">
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                      <span>{{$t('device.distribute') }}</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 无数据 -->
          <div v-if="noDataControl">
            <el-table height="50vh" stripe border :empty-text="$t('message.nodata')">
              <el-table-column :label="$t('device.Field_Name')"></el-table-column>
              <el-table-column :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.set')"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
            </el-table>
          </div>
        </div>
        </device-dialog>

        <!-- 固件升级 -->
        <!-- v-if="upgradeDeviceVisible" -->
        <device-dialog :title="$t('device.device_upgrade')" :visible.sync="upgradeDeviceVisible"
          :class="{ 'showDialog': upgradeDeviceVisible, 'hideDialog': !upgradeDeviceVisible }" width="580px" noFooter>
          <div slot="content">
            <el-form class="grid upload-container upgradeNew"  element-loading-spinner="el-icon-loading" v-loading="loadingupgradeDev">
              <el-form-item :label="$t('device.select_firmware')" size="small">
                <el-select v-model="searchrecharge.firmware" @change="voltageArr($event)"
                  :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
                  <template slot="empty">
                    <div style="text-align:right;">
                      <button class="upFirewareBtn" @click="addFirmware()">{{ $t('firmware.Upload_firmware')
                      }}</button>
                    </div>
                  </template>
                  <div style="text-align:right;">
                    <button class="upFirewareBtn" @click="addFirmware()">{{ $t('firmware.Upload_firmware') }}</button>
                  </div>
                  <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('device.firmware_type')" size="small">
                <el-select v-if="!hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in firmwaretypelist" :key="item.id" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-select v-if="hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
                  popper-class="select-search-recharge" ref="autoSelected">
                  <el-option v-for="item in firmwaretypelist1" :key="item.id" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('device.upgrade_brate')" size="small">
                <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in bratelist" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label=" ">
                <div class="progressShowEquipment">
                    <div class="processstatueEquipment" v-show="progressUp">{{ $t('firmware.upgrading') }}</div>
                    <div :class="progressFlag==0?'processstatueEquipment':'processstatueEquipment1'" v-show="progerssComplete">{{resultTitle}}</div>
                    <!-- <div class="progressName">
                      <i class="iconfont icon-fujian"></i>
                      {{ firmwareName }}
                    </div>
                    <div class="progressCancel" @click="upgradeCancel">
                      <i class="iconfont icon-delete"></i>
                    </div> -->
                  </div>
                  <div class="processDataEquipment" v-show="progressUp">
                    <el-progress :format="progressText" :percentage="progress" :stroke-width="10" color="#33FFB6"></el-progress>
                    <!-- <div class="processBig">{{ uploadNowSize }}M / {{ uploadTotalSize }}M</div> -->
                  </div>
              </el-form-item>
            </el-form>
            <div style="text-align:right;">
              <button style="margin-right: 20px;"  v-show="progressUp" class="btn btn-dark"  @click="upgradeCancel">{{ $t('firmware.upgrade_quit6') }}</button>
              <el-button class="elbtn btn-dark" :disabled="upgradebButtonStatus"  @click="submitUpgradeDevice">{{ $t('device.confirm') }}</el-button>
            </div>
          </div>
          <div slot="footer">
            <!-- <button
              class="button-hollow"
              @click="upgradeDeviceVisible = false"
            >{{$t('device.cancel')}}</button>-->
            <!-- <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button> -->
          </div>
        </device-dialog>
        <!-- 固件升级二次弹窗（增加固件的对话框） -->
        <!-- style="z-index:2014!important;" -->
        <!-- v-if="dialogAdd" -->
        <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
        <updateDialog :title="$t('firmware.Upload_firmware')" :visible.sync="dialogAdd" v-if="dialogAdd" width="40vw"
          noFooter style="z-index:3000;">
          <div slot="content">
            <el-form class="grid upload-container">
              <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
              <el-form-item :label="$t('firmware.Firmware_description')" size="small">
                <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('browse.desc')" size="small">
                <el-input v-model="remark" :placeholder="$t('firmware.enter_content')"></el-input>
              </el-form-item>
              <el-form-item label=" ">
                <div class="upload-contents">
                  <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                    <i class="iconfont icon-shangchuan1"></i>
                    <!-- {{$t('datalogger.Upload')}} -->
                  </button>
                  <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
                  <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                    @change="uploadfile($event)" />
                </div>
              </el-form-item>
            </el-form>
            <div style="text-align:right;">
              <button class="btn btn-dark" @click="dialogAdd = false">{{ $t('datalogger.confirm') }}</button>
              <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
            </div>
          </div>
          <div slot="footer">
            <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
            <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
          </div>
        </updateDialog>
        <!-- 升级结果提示(成功) -->
        <!-- v-if="upgradeDeviceSucVisible" -->
        <device-dialog :title="$t('project.upgradeResults')" :visible.sync="upgradeDeviceSucVisible"
          :class="{ 'showDialog': upgradeDeviceSucVisible, 'hideDialog': !upgradeDeviceSucVisible }" width="500px"
          noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t('project.upgradeSuc') }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="upgradeDeviceSucVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 升级结果提示(失败) -->
        <!-- v-if="upgradeDeviceFailVisible" -->
        <device-dialog :title="$t('project.upgradeResults')" :visible.sync="upgradeDeviceFailVisible"
          :class="{ 'showDialog': upgradeDeviceFailVisible, 'hideDialog': !upgradeDeviceFailVisible }" width="500px"
          noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="upgradeDeviceFailVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>

        <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
        <!-- v-if="deletingDeviceInfo" -->
        <device-dialog :visible.sync="deletingDeviceInfo"
          :class="{ 'showDialog': deletingDeviceInfo, 'hideDialog': !deletingDeviceInfo }" width="30vw" noFooter>
          <div class="content_tishi" slot="content">
            <div class="tital">
              <!-- <i class="iconfont icon-gantanhao"></i> -->
              <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('device.confirm_deldte') }}</span>
            </div>
            <div class="disabledescr">
              <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('account.notRecovered') }}</span>
            </div>
            <div class="deletfotter" style="text-align:right;margin-top:28px;">
              <button class="btn btn-dark" style="margin-right:10px;" @click="submitDeleteDevice">{{ $t('device.confirm')
              }}</button>
              <button class="btn btn-light" @click="deletingDeviceInfo = null">{{ $t('device.cancel') }}</button>
            </div>
          </div>
        </device-dialog>
        <!-- 删除结果提示(成功) -->
        <!-- v-if="delDeviceSucVisible" -->
        <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceSucVisible"
          :class="{ 'showDialog': delDeviceSucVisible, 'hideDialog': !delDeviceSucVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showsuccess"></span>
              <span class="showresulttext">{{ $t('project.delSuc') }}</span>
              <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="delDeviceSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
              </div>
            </div>
          </div>
        </device-dialog>
        <!-- 删除结果提示(失败) -->
        <!-- v-if="delDeviceFailVisible" -->
        <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceFailVisible"
          :class="{ 'showDialog': delDeviceFailVisible, 'hideDialog': !delDeviceFailVisible }" width="500px" noFooter>
          <div slot="content">
            <div class="showresultbox">
              <span class="showbase showfail"></span>
              <span class="showresulttext">{{ deviceTipMsg }}</span>
              <!-- 确定 -->
              <div class="showoperate">
                <button class="btn btn-dark" @click="delDeviceFailVisible = false;">{{ $t('datalogger.confirm')
                }}</button>
              </div>
            </div>
          </div>
        </device-dialog>

        <!-- 导出报表 -->
        <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>
        <!-- ==========设备相关弹窗结束========== -->
      </div>
    </div>
    <!-- <div class="p-bottom"></div> -->
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import deviceDialog from "@/components/dialognew";
import updateDialog from "@/components/dialognew/flowIndex";
import exportPlantDialog from "@/components/dialognew/exportPlant";
import { i18n } from "@/i18n";
import clipboard from "@/assets/js/clipboard";
// import config from "@/assets/js/config";
import filter from "@/assets/js/filter";
import config from '@/assets/js/config';

// 设备列表[本页](含操作)
// 数采器列表[抽离](含操作)
import tabDatalogger from "./projectNew/tabDatalogger";

export default {
  components: {
    deviceDialog,
    updateDialog,
    exportPlantDialog,
    // 数采器列表[抽离](含操作)
    tabDatalogger
  },
  data () {
    return {
      upgradebButtonStatus:false,
      loadingupgradeDev:false,
      datalogger: {
        devaddr: ""
      },
      hideFlag: false,//德业域名显隐
      noDataControl: false,
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        // brand: "",
        pn: "",
        // search: ""
      },
      xieyi: [],
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0"
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelistUPG: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "1"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "2"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "3"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "4"
        }
      ],
      firmwaretypelist: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
      ],
      firmwaretypelist1: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id: 15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id: 16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0"
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400"
        },
        {
          label: 4800,
          value: "4800"
        },
        {
          label: 9600,
          value: "9600"
        },
        {
          label: 19200,
          value: "19200"
        },
        {
          label: 38400,
          value: "38400"
        },
        {
          label: 57600,
          value: "57600"
        },
        {
          label: 115200,
          value: "115200"
        }
      ],
      loadingdevice: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      }, //分页数据
      // deviceList: [],
      //批量操作
      selectedDevice: [],
      tableDataBse: [],
      tableDataStd: [],
      tableDataSvs: [],
      tableDataPvs: [],
      tableDataGrd: [],
      tableDataBat: [],
      tableDataCts: [],
      tableDataLos: [],
      tableDataBas: [],
      tableDataAdv: [],
      tableDataElse: [],
      tableDataHuangJinTai: [], //黄金台定制
      controlinter: [],
      controlvalue: "",
      editDeviceInfo: null,
      debugDeviceVisible: false,
      debugDeviceId: null,
      upgradeDeviceVisible: false,
      upgradeDeviceterId: null,
      deletingDeviceInfo: null,
      controlDeviceVisible: false,
      statisticDialogVisible: false, //统计弹窗是否可见
      formEdit: {
        sn: "",
        deviceSn: "",
        pn: "",
        devaddr: "",
        devcode: "",
        alias: ""
      },
      device: {
        pn: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
      // 显示新建项目
      // showCreateProject: false,
      // 项目名称
      pname: "",
      // 显示上传固件二层弹窗
      dialogAdd: false,
      desc: "",
      remark: "",//备注
      // 项目操作
      createProjectVisible: false,
      editProjectVisible: false,
      delProjectVisible: false,
      deletingProjectInfo: null,
      // 项目新建与编辑
      pFormData: {
        pid: "",
        name: "",
        pname: "",
        // picSmall: "",
        // picProjectPic: "",
        remark: ""
      },
      formDataRules: {
        name: [
          {
            required: true,
            message: this.$t("datalogger.cp10"),
            trigger: "blur"
          }
        ]
      },
      // // 上传图片弹窗按钮
      // upbtnVisible: true,
      // 项目列表
      proList: [],
      // 项目设备列表
      deviceList: [],
      // 所属项目选择
      pidSelect: [],
      // 修改设备
      editDeviceVisible: false,
      // 修改设备成功提示
      editDeviceSucVisible: false,
      // 修改设备失败提示
      editDeviceFailVisible: false,
      // 升级设备成功
      upgradeDeviceSucVisible: false,
      // 升级设备失败
      upgradeDeviceFailVisible: false,
      // 删除设备成功
      delDeviceSucVisible: false,
      // 删除设备失败
      delDeviceFailVisible: false,
      // 新建项目成功提示弹窗
      createProjectSucVisible: false,
      // 新建项目失败提示弹窗
      createProjectFailVisible: false,
      // 编辑项目成功提示弹窗
      editProjectSucVisible: false,
      // 编辑项目失败提示弹窗
      editProjectFailVisible: false,
      // 删除项目成功提示弹窗
      delProjectSucVisible: false,
      // 删除项目失败提示弹窗
      delProjectFailVisible: false,
      // 操作设备返回提示(错误时)
      deviceTipMsg: "",
      // 搜索弹出
      showSearch: false,
      // 当前选中项目ID(原本空)
      proCurrentPid: 0,
      // 导出报表
      exportPlantParams: [],
      // 项目管理右侧Tab切换
      activeName: "ptabsn",
      flag:false,
      resultTitle:"",
      progressFlag:Number,
    };
  },
  watch: {
    "getIsShow.isShow"(){
      this.devDebug.cmd = null;
      this.debugReturn = null;
      if (this.getIsShow.isShow==2) {
        this.deviceListFalg=false
        this.deviceDebugFalg=false
      }
    },
    // 监听控制项弹框，触发其中的日期时间选择器弹框关闭
    controlDeviceVisible (val) {
      if (!val) {
        this.clickClosePicker()
      }
    },
    // deleteDeviceVisible(val) {
    //   if (!val) this.deletingDeviceInfo = null;
    // },
    upgradeDeviceVisible (val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
        this.upgradebButtonStatus = false;
      }
    },
    // 响应更新电站列表事件
    "$store.state.event.updateProjectList" (val) {
      if (val) {
        this.getProjectList(true);
        this.$store.state.event.updateProjectList = false;
      }
    },
    // 响应更新电站列表事件
    "$store.state.event.updateDeviceList" (val) {
      if (val) {
        this.getDeviceList(true);
        this.$store.state.event.updateDeviceList = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo",
      getIsShow: "getIsShow",
      upgradeUPG: "getUpgradeUPG",
      UpgradeTypeUPG: "getUpgradeTypeUPG",
    }),
    ...mapState({
      // 角色
      role: (state) => {
        return {
          id: state.user.role,
          name: filter.role(state.user.role).name,
          group: filter.role(state.user.role).group,
        };
      },
      method: (state) => state.user.method,
      isMicroService: (state) => state.user.isMicroService,
      code: (state) => state.user.code,
      resData: (state) => state.user.resData,
    }),
  },
  beforeDestroy(){
    this.$store.commit("saveIsShow",1)
  },
  created () {
    this.$store.commit("saveIsShow",1)
    // 项目
    this.getProjectList();
    this.showHides();
    // 项目下设备
    // this.getProjectDeviceList();
  },
  // mounted() {
  //   // 编辑与新建项目时上传图片按钮显隐
  //   this.$nextTick(() => {
  //     this.upbtnVisible = true;
  //     this.$set(this.pFormData, 'picSmall', '');
  //   });
  // },
  methods: {
    // 控制项操作处理
    OperationStyle({row,column,rowIndex,columnIndex}){
      if (columnIndex==3) {
        return "background:#222d35;"
      }
    },
    //德业域名
    showHides () {
      var hostname = window.location.hostname;
      if (hostname == "deye.dessmonitor.com") {
        this.hideFlag = true
      }
    },
    // 返回
    goback () {
      // this.$router.go(-1);
      this.$router.push('/home')
    },
    progressText (progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    // 点击进入设备
    enterDevice (info) {
      // this.$store.commit("saveDeviceInfo", {
      //   pn: info.pn,
      //   sn: info.sn,
      //   devcode: info.devcode,
      //   devaddr: info.devaddr
      // });
      this.$router.push({
        // path: '/generalNew/home',
        path: `/${this.role.group}New/home`,
        query: {
          tool: {
            // 'curDeviceMark': 'Suc',
            curDeviceInfo: info
          }
        }
      });
    },
    // 编辑设备
    editDevice (info) {
      // console.log('edit-project=>info', info);
      this.editDeviceVisible = true;
      this.formEdit = { ...info };
    },
    // 确定修改逆变器
    submitEditDevice () {
      let param = {
        pn: this.formEdit.pn,
        sn: this.formEdit.sn,
        devaddr: this.formEdit.devaddr,
        devcode: this.formEdit.devcode,
        alias: this.formEdit.devalias
      };
      this.$request.get("editDeviceInfo", param).then(res => {
        if (res.err == 0) {
          // this.$message.success(this.$t("device.modifySuc"));
          this.editDeviceVisible = false;
          this.editDeviceSucVisible = true;
          // window.location.reload();
          this.formEdit = {};
          // 通知设备列表更新
          this.$store.state.event.updateDeviceList = true;
          this.getDeviceList();
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.deviceTipMsg = this.$t(`errCode.${res.err}`);
          this.editDeviceFailVisible = true;
        }
      });
    },
    // 返回列表
    goList(){
      this.$store.commit("saveIsShow",1)
    },
    // 调试设备
    debugDevice (info) {
      this.devDebug.cmd = null;
      this.debugReturn = null;
      this.$store.commit("saveIsShow",3)
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        status: info.status,
        descx: info.descx,
        load: info.load,
        edate: info.edate,
        brand: info.brand,
        devalias: info.alias,
        collalias: info.calias,
        signal: info.signal,
        usr: info.usr,
        device_Firmware_Version: info.fireware,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
        otaLabel: info.otaLabel,
      });
    },
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // 设备发送指令
    submitDebugDevice () {
      if (this.device.status == "1") {
        this.$message.error(this.$t("device.Debugfail"));
      } else {
        this.debugReturn = this.$t("device.instruction_response");
        let param = {
          pn: this.deviceInfo.pn,
          devaddr: this.deviceInfo.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.debug_suc"));
            this.debugReturn = res.dat.dat;
            // this.debugDeviceVisible = false;
            // this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 数采器发送指令
    submitDebugDatalogger () {
      if (this.datalogger.devaddr == null) {
        this.$message.error(this.$t("datalogger.devaddrfail"));
      } else if (this.datalogger.status == "1") {
        this.$message.error(this.$t("datalogger.Debugfail"));
      } else {
        this.debugReturn = this.$t("datalogger.instruction_response");
        let param = {
          pn: this.deviceInfo.pn,
          devaddr: this.datalogger.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("datalogger.debug_suc"));
            this.debugReturn = res.dat.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 控制项日期时间选择窗口关闭处理
    clickClosePicker(){
      if (this.$refs['controlDatepickerRef-system_time']) {
        this.$refs['controlDatepickerRef-system_time'].hidePicker()
      }
      if (this.$refs['controlDatepickerRef-sys_system_time']) {
        this.$refs['controlDatepickerRef-sys_system_time'].hidePicker()
      }
    },
    // 控制项
    controlDevice (info) {
      this.controlDeviceVisible = true;
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        i18n: this.$lang.currentLang,
        role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then(res => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          let arr1 = [],
            arr2 = [],
            arr3 = [],
            arr4 = [],
            arr5 = [],
            arr6 = [],
            arr7 = [],
            arr8 = [],
            arr9 = [],
            arr10 = [],
            arr11 = []

          tableData.forEach(field => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach(item => {
                // 增
                if (item.val == "undefined" || item.val == "null") {
                  item.val = "--";
                }
                field.controlinter.push({
                  label: item.val,
                  value: item.key
                });
              });
              //默认显示第一项
              // field.controlvalue = field.item.length ? field.controlinter[0].value: "";
              //不显示任由选择
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              arr1.push(field);
            } else if (s.startsWith("std_")) {
              arr2.push(field);
            } else if (s.startsWith("sys_")) {
              arr3.push(field);
            } else if (s.startsWith("pvs_")) {
              arr4.push(field);
            } else if (s.startsWith("grd_")) {
              arr5.push(field);
            } else if (s.startsWith("bat_")) {
              arr6.push(field);
            } else if (s.startsWith("cts_")) {
              arr7.push(field);
            } else if (s.startsWith("los_")) {
              arr8.push(field);
            } else if (s.startsWith("bas_")) {
              arr10.push(field);
            } else if (s.startsWith("adv_")) {
              arr11.push(field);
            } else {
              arr9.push(field);
            }
            // this.huoquInverter(field)
          });
          this.tableDataAdv = arr11;
          this.tableDataBas = arr10;
          this.tableDataElse = arr9;
          this.tableDataLos = arr8;
          this.tableDataCts = arr7;
          this.tableDataBat = arr6;
          this.tableDataGrd = arr5;
          this.tableDataPvs = arr4;
          this.tableDataSvs = arr3;
          this.tableDataStd = arr2;
          this.tableDataBse = arr1;
        } else {
          this.noDataControl = true;
          this.tableDataAdv = [];
          this.tableDataBas = [];
          this.tableDataElse = [];
          this.tableDataLos = [];
          this.tableDataCts = [];
          this.tableDataBat = [];
          this.tableDataGrd = [];
          this.tableDataPvs = [];
          this.tableDataSvs = [];
          this.tableDataStd = [];
          this.tableDataBse = [];
        }
      });
      //黄金台设备调用下方黄金台定制funtcion
      if (info.devcode == 2384) {
        this.getHuangjintaiControl(info);
      } else if (info.devcode == 2366) {
        this.getHuangjintaiControl(info);
      } else {
        this.tableDataHuangJinTai = [];
      }
    },
    //黄金台定制,获取电池电压和倍率
    getHuangjintaiControl (info) {
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr
      };
      this.$request.get("queryCtrlHuangJinTaiView", param).then(res => {
        if (res.err == 0) {
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: res.dat.voltage,
            multiply: res.dat.multiply
          });
        } else if (res.err == 8) {
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: 12,
            multiply: 0.09
          });
        } else {
          this.tableDataHuangJinTai = [];
        }
      });
    },
    huangjintaiChange (val) {
      var volArr = [
        { key: "12V", val: 12 },
        { key: "24V", val: 24 },
        { key: "48V", val: 48 },
        { key: "96V", val: 96 }
      ];
      var mulArr = [
        { key: "0.09", val: 0.09 },
        { key: "0.18", val: 0.18 },
        { key: "0.36", val: 0.36 },
        { key: "0.72", val: 0.72 }
      ];
      volArr.forEach((element, index) => {
        if (element.val == val) {
          this.tableDataHuangJinTai[0].multiply = mulArr[index].val;
        }
      });
    },
    // 控制项获取当前值
    huoquInverter (info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        id: info.id,
        i18n: this.$lang.currentLang
      };
      this.$set(info, "isLoading", true);
      // info.isLoading = true;
      this.$request.get("queryDeviceCtrlValue", param).then(res => {
        if (res.err == 0) {
          if (res.dat.val == "undefined" || res.dat.val == "null") {
            res.dat.val = "--";
          }
          // if(info.controlinter.length){
          //   this.$set(info, 'controlvalue', res.dat.key||res.dat.val)
          // }else{
          //   this.$set(info, 'controlvalue', res.dat.val)
          // }
          if(info.controlinter.length){
            info.controlinter.forEach((item) => {
              //  此处处理用的label和接口返回的val匹配忽略大小写
                if (item.label == res.dat.val) {
                  this.$set(info, 'controlvalue', item.value)
                }else if(item.label.toString().toLowerCase() == res.dat.val.toString().toLowerCase()){
                  this.$set(info, 'controlvalue', item.value)
                }
            });
            if(!info.controlvalue)
            this.$set(info, 'controlvalue', res.dat.val || this.$t("nodata"))
          }else{
            this.$set(info, 'controlvalue', res.dat.val || this.$t("nodata"))
          }
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.isLoading = false;
        this.$set(info, "isLoading", false);
      }).catch(() => {
          this.$set(info, "isLoading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
    },
    // 下发指令(黄金台)
    xiafaInverterHuangJinTai (info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        voltage: info.voltage,
        multiply: info.multiply
      };
      // info.Loading = true;
      this.$set(info, "Loading", true);
      this.$request.get("ctrlHuangJinTaiView", param).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t("device.Send_suc"));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.Loading = false;
        this.$set(info, "Loading", false);
      });
    },
    // 下发指令
    xiafaInverter (info) {
      if (!info.controlvalue) {
        this.$message.error(this.$t("device.Send_Input"));
      } else {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          val: info.controlvalue,
          i18n: this.$lang.currentLang
        };
        this.$set(info, "Loading", true);
        // info.Loading = true;
        this.$request.get("ctrlDevice", param).then(res => {
          // this.$request.get("ctrlDevice", param).then(res => {
          if (res.err == 0) {
            if (this.controlparams.devcode == 2352) {
              var medium = res.dat.dat.substring(27, 29);
              if (medium == "31") {
                this.$message.success(this.$t("device.Send_suc"));
              } else {
                this.$message.error(this.$t("device.Send_fail"));
              }
            } else {
              this.$message.success(this.$t("device.Send_suc"));
            }
          } else {
            if (this.controlparams.devcode == 2376) {
              if (res.desc.match(/\(([^)]*)\)/)) {
                this.$message.error(res.desc.match(/\(([^)]*)\)/)[1]);
              } else {
                // 获取错误提示，如果没有匹配到则使用默认提示
                const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
              }
            } else {
              // 获取错误提示，如果没有匹配到则使用默认提示
              const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
              this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
            }
            // this.$message.error(this.$t(`errCode.${res.err}`));
          }
          // info.Loading = false;
          this.$set(info, "Loading", false);
        }).catch(() => {
          this.$set(info, "Loading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
      }
    },
    voltageArr (item) {
      this.rechargelist.forEach(element => {
        if (element.id == item) {
          this.searchrechargeContents = element;
        }
      });
    },
    // 设备固件升级
    upgradeDevice (info) {
      Object.assign(this.$data.firmwaretypelist,this.$options.data.call(this).firmwaretypelist)
      Object.assign(this.$data.firmwaretypelist1,this.$options.data.call(this).firmwaretypelist1)
      this.searchrecharge.firmwaretype = "0"
      this.searchrecharge.brate = "0"
      this.$request.getUPG(`/upg/api/auth/web/device/upgradeType/${info.devcode}`).then(res=>{
        if(res.code == 0){
         if(res.data.items && res.data.items.length != 0){
          this.$store.commit('saveUpgradeUPG', true);
          // Object.assign(this.firmwaretypelist,res.data.items)
          res.data.items.map(item => {
        item.value = item.id;
        item.label = item.typeName;
      });
          this.firmwaretypelist = res.data.items
          this.searchrecharge.firmwaretype =  res.data.items[0].id
          this.queryFirmware();
          this.queryDeviceUpgradeStatus(info)
         }else{
          this.$store.commit('saveUpgradeUPG', false);
          // this.$request.get(`queryDevUpMode`,{pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr,}).then(res=>{
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr}).then(res=> {
             if(res.code == 0){
              if(res.data ==1){
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.getUpgFirmwaretypeNom()
              }else{
                this.$store.commit('saveUpgradeTypeUPG', false);
         }
             }else{
               this.$store.commit('saveUpgradeTypeUPG', false);
             }
         this.queryFirmware();
         this.queryDeviceUpgradeStatus(info)
           })
         }
        }else{
          this.$store.commit('saveUpgradeUPG', false);
          // this.$request.get(`queryDevUpMode`,{pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr,}).then(res=>{
          this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDevUpMode", {pn:info.pn,sn:info.sn,devcode:info.devcode,devaddr:info.devaddr}).then(res=>{
             if(res.code == 0){
              if(res.data ==1){
                this.$store.commit('saveUpgradeTypeUPG', true);
                this.getUpgFirmwaretypeNom()
              }else{
                this.$store.commit('saveUpgradeTypeUPG', false);
        }
             }else{
               this.$store.commit('saveUpgradeTypeUPG', false);
             }
             this.queryFirmware();
             this.queryDeviceUpgradeStatus(info)
      })
        }
      }).catch(() => {
        this.$store.commit('saveUpgradeTypeUPG', false);
        this.queryFirmware();
        this.queryDeviceUpgradeStatus(info)
      })
    
      this.upgradeDeviceVisible = true;
      this.dataparams = info;
      this.progerssComplete = false;
    },
    getUpgFirmwaretypeNom() {
        this.$request.getUPG(`/upg/api/auth/web/device/upgradeType`).then(res=>{
        if(res.code == 0){
          if(res.data.items && res.data.items.length != 0){
            var arrList =[]
            res.data.items.forEach((element,index) => {
              arrList.push({
                value:element.id,
                label:element.typeName,
                id:index,
              })
           })
            this.firmwaretypelist=arrList
            this.searchrecharge.firmwaretype =  this.firmwaretypelist[0].value
          }
        }
       });
     },
    // 查询设备升级状态
    queryDeviceUpgradeStatus(info){
      let params = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      }
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        this.$request
          .getUPG("/upg/api/auth/web/device/upgradeStatus", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                this.keyProgress = res.data.key;
                this.upgradebButtonStatus = true;
                this.queryProgress();
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
              }
            }
          });
      }else{
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeStatus",params).then(res=>{
        if (res.code==0) {
          if (res.data.status==0) {
            this.keyProgress=res.data.key
            this.upgradebButtonStatus = true;
            this.queryProgress()
          }
        }
      })
      }
    },
    // 查询固件列表
    queryFirmware () {
      this.searchrecharge.firmware = null;
      this.rechargelist = [];
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let parmas = {
          page: 1,
          pageSize: 50
        };
        this.loadingupgradeDev = true
        // 接入UPG升级
        this.$request
          .getUPG("/upg/api/auth/web/device/firmwares", parmas)
          .then(res => {
            if (res.code == 0) {
              res.data.items.forEach(item => {
               this.rechargelist.push({
              id: item.id,
              firmware: item.firmwareName,
              size: item.fileSize
            });
          });
            }
            this.loadingupgradeDev = false
          });
      }else{
        this.loadingupgradeDev = true
        this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then(res => {
        if (res.code == 0) {
          res.data.items.forEach(item => {
            this.rechargelist.push({
              id: item.id,
              firmware: item.firmware,
              size: item.size
            });
          });
        }
        this.loadingupgradeDev = false
      });
      }

    },
    //增加固件进入界面按钮
    addFirmware() {
      this.dialogAdd = true;
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
        this.desc = null;
        this.remark = null;
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("device.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("device.error1"));
        return;
      }
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let parmas = {
        firmwareName:file.name,
        versionNote:'V1.0',
        deleteFlag:'0',
        upgradeMode:1,
        note:this.desc,
      }
      this.$request.uploadFirmware('/upg/api/auth/web/device/firmware',file, parmas).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
          // this.upgradeDeviceVisible = false;
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else {
          this.$message.error(res.message);
          // 关闭二次弹窗
          this.dialogAdd = false;
        }
        this.queryFirmware();
      });
      }else{
        this.$request.uploadfileAxios(file, this.desc, this.remark).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
          // this.upgradeDeviceVisible = false;
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
          // 关闭二次弹窗
          this.dialogAdd = false;
        }
        this.queryFirmware();
        // this.upgradeDeviceVisible = false;
      });
      }

    },
    // 确认固件升级
    submitUpgradeDevice () {
      this.resultTitle=""
      this.flag = true;
      this.progress = 0;
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        this.upgradebButtonStatus = true;
        if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
          let UPGparams = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
          // 接入UPG升级
          this.$request
            .postUPG("/upg/api/auth/web/device/upgradeTransmission", UPGparams)
            .then(res => {
              if (res.code == 0) {
            if (res.data.status == 0) {
              this.keyProgress = res.data.key;
              this.$message.success(this.$t("device.Upgrading"));
              this.queryProgress();
            } else if (res.data.status == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              this.upgradebButtonStatus = false;
            } else if (res.data.status == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              this.upgradebButtonStatus = false;
            } else if (res.data.status == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              this.upgradebButtonStatus = false;
            }
          } else {
            this.$message.error(res.message);
            this.upgradebButtonStatus = false;
          }
            });
        }else{
          let params = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              this.$message.success(this.$t("device.Upgrading"));
              this.queryProgress();
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              this.upgradebButtonStatus = false;
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              this.upgradebButtonStatus = false;
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              this.upgradebButtonStatus = false;
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            this.upgradebButtonStatus = false;
          }
        });
        }
      }
    },
    // 查询升级进度
    queryProgress () {
      this.progressUp = true;
      this.progerssComplete = false;
      // 如果已存在定时器，先清除
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let params = {
        pn: this.dataparams.pn,
        // devaddr: this.dataparams.devaddr,
        // devcode: this.dataparams.devcode,
        // sn: this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request
          .getUPG("/upg/api/auth/web/device/upgradeProgressByKey", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  this.progressFlag=res.data.status
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.progressSuc();
                  this.resultTitle=this.$t("firmware.updateCompleted")
                  return;
                }
              }  else if (res.data.status == 1) {
                // =》'升级异常，已退出'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit1")
                return;
              } else if (res.data.status == 2) {
                // =》'升级失败,请稍后再试'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit2")
                return;
              } else if (res.data.status == 3) {
                // =》'升级成功'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit3")
                return;
              } else if (res.data.status == 4) {
                // =》'升级被手动取消'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit4")
                return;
              } else if (res.data.status == 5) {
                // =》'未在升级中'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit5")
                return;
              }
            }else {
              this.progressUp = false;
              this.progerssComplete = true;
              this.resultTitle=this.$t(`errCode.${res.err}`)
              clearInterval(this.interval);
              this.interval = null;
              this.upgradebButtonStatus = false;
            }
          });
      }, 2000);

      }else{
        let params = {
        pn: this.dataparams.pn,
        devaddr: this.dataparams.devaddr,
        devcode: this.dataparams.devcode,
        sn: this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  this.progressFlag=res.data.status
                  clearInterval(this.interval);
                  this.interval = null;
                  this.upgradebButtonStatus = false;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.progressSuc();
                  this.resultTitle=this.$t("firmware.updateCompleted")
                  return;
                }
              }  else if (res.data.status == 1) {
                // =》'升级异常，已退出'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit1")
                return;
              } else if (res.data.status == 2) {
                // =》'升级失败,请稍后再试'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit2")
                return;
              } else if (res.data.status == 3) {
                // =》'升级成功'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit3")
                return;
              } else if (res.data.status == 4) {
                // =》'升级被手动取消'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit4")
                return;
              } else if (res.data.status == 5) {
                // =》'未在升级中'
                clearInterval(this.interval);
                this.interval = null;
                this.upgradebButtonStatus = false;
                // 升级操作完毕
                this.progressUp = false;
                this.progerssComplete = true;
                this.resultTitle=this.$t("firmware.upgrade_quit5")
                return;
              }
            }else {
              this.progressUp = false;
              this.progerssComplete = true;
              // this.resultTitle=this.$t(`errCode.${res.code}`)
              this.resultTitle=res.message
              clearInterval(this.interval);
              this.interval = null;
              this.upgradebButtonStatus = false;
            }
          });
      }, 2000);
      }

    },
    progressSuc(){
      if (this.flag) {
      this.$message.success(this.$t("device.Update_Completed"));
      this.flag = false;
      }
    },
    //取消升级
    upgradeCancel () {
      if(this.upgradeUPG.upgradeUPG|| this.UpgradeTypeUPG.UpgradeTypeUPG){
        let parmas = {
          pn: this.dataparams.pn,
          key: this.keyProgress
        }
        this.$request.putUPG('/upg/api/auth/web/device/upgradeCancel',parmas).then(res=>{
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
            this.progressUp = false
            clearInterval(this.interval);
            this.upgradebButtonStatus = false;
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        })
      }else{
        this.$request.putUPG("/upg/api/auth/web/shineDess/device/upgrade/deviceCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.progressUp = false
            clearInterval(this.interval);
            this.upgradebButtonStatus = false;
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
      }
    },
    // 删除设备
    deleteDevice (info) {
      this.deletingDeviceInfo = {
        pn: info.pn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        sn: info.sn
      };
    },
    // 确定删除设备
    submitDeleteDevice () {
      this.$request
        .get("delDeviceFromPlant", this.deletingDeviceInfo)
        .then(res => {
          if (res.err == 0) {
            // this.$message.success(this.$t("device.deleteSuc"));
            this.delDeviceSucVisible = true;
            this.deletingDeviceInfo = null;
            this.getDeviceList();
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.deviceTipMsg = this.$t(`errCode.${res.err}`);
            this.delDeviceFailVisible = true;
          }
        });
    },
    //勾选多项
    changeFun (val) {
      this.selectedDevice = val; // 返回的是选中的列的数组集合
    },
    // 给下发指令该列增加样式
    // (row, column, rowIndex, columnIndex)
    changeCellStyle (row) {
      if (row.column.label == i18n.t("device.Send_Command")) {
        return "background: linear-gradient(0deg, rgba(60, 75, 87, 1) 5.36%, rgba(42, 54, 63, 1) 100%);box-shadow: -1px -1px 11px rgba(74, 74, 74, 0.06), 0px 4px 4px rgba(0, 0, 0, 0.25);";
      } else {
        return "";
      }
    },
    //获取项目列表数据
    getProjectList () {
      let param = {
        i18n: this.$lang.currentLang,
        itemType:5,
        businessId: "4"
      };
      this.$request.postMicroserDess("/dgm/api/dgm/itemgroupeybond/lists", param).then(res => {
        if (res.code == 0) {
          // 兼容：res.data[0].items可能为null/非数组/缺失，此时proList为空
          const groupItems = Array.isArray(res.data) && res.data[0] && Array.isArray(res.data[0].items)
            ? res.data[0].items
            : [];
          this.proList = groupItems.map(item => ({
            ...item,
            pid: item.id,
            pname: item.itemName,
          }));
          // 无项目时proList为空、proCurrentPid也置空，但仍继续请求设备列表(查全部设备)
          this.proCurrentPid = this.proList.length > 0 ? this.proList[0].pid : "";
          let param2 = {
            pid: this.proCurrentPid,
            devtype: 2304,
            page: 1,
            pageSize: 15,
            orderBy: "descfocus"
          };
          this.loadingdevice = true;
          this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param2).then(res => {
            if (res.code == 0) {
              this.deviceList = this.Fnreturndev(res);
              this.pagination.total = res.data && res.data.total || 0;
            } else {
              // this.$message.warning(this.$t(`errCode.${res.err}`));
              this.deviceList = [];
              this.pagination.total = 0;
            }
            this.loadingdevice = false;
          });
        }
      });
    },
    //获取项目下设备列表数据
    // status，devtype(2304)， plantid，page(0)，pagesize (100)
    getProjectDeviceList (info) {
      this.$store.commit("saveIsShow",1)
      this.proCurrentPid = info.plantid;
      let param = {
        pid: this.proCurrentPid,
        ...this.search,
        deviceStatus: this.search.status,
        devtype: 2304,
        page: 1,
        pageSize: 15,
        orderBy: "descfocus"
      };
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0) {
          this.deviceList = this.Fnreturndev(res);
          this.pagination.total = res.data.total;
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.deviceList = [];
          this.pagination.total = 0;
        }
      });
    },
    // 获取表格数据（设备）
    getDeviceList (reset) {
      if (reset) this.pagination.currentPage = 1;
      let param = {
        pid: this.proCurrentPid,
        ...this.search,
        deviceStatus: this.search.status,
        devtype: 2304,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pagesize,
        // page: 0,
        // pagesize: 100,
        orderBy: "descfocus"
      };
      this.loadingdevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0) {
          this.deviceList = this.Fnreturndev(res);
          this.pagination.total = res.data.total;
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.deviceList = [];
          this.pagination.total = 0;
        }
        this.loadingdevice = false;
      });
    },
    // 新建项目
    createProject () {
      this.$store.commit("saveIsShow",1)
      this.createProjectVisible = true;
      // this.upbtnVisible = true;
      // this.pFormData.name ='';
      this.$set(this.pFormData, "name", "");
      this.$set(this.pFormData, "remark", "");
      // this.$set(this.pFormData, "picSmall", "");
      this.$refs.pFormDataAdd.resetFields();
    },
    submitCreateProject () {
      this.$refs.pFormDataAdd.validate(valid => {
        if (!valid) return false;
      let param = {
        name: this.pFormData.name,
        remark: this.pFormData.remark,
        itemType: 5,
        businessId: "4",
        timezone: '28800',
      };
      this.$request.postMicroserDess("/dgm/api/auth/web/itemseybond/saveNewItemForDIS", param).then(res => {
        if (res.code == 0) {
          this.formEdit = {};
          // 通知项目列表更新(watcher统一刷新，不再直接调用getProjectList避免重复请求)
          this.$store.state.event.updateProjectList = true;
          this.createProjectVisible = false;
          this.createProjectSucVisible = true;
        }else{
          this.deviceTipMsg = res.message||res.errorMessage;
          this.createProjectFailVisible = true;
        }
      });
     });
    },
    // 编辑项目
    editProject (info) {

      this.editProjectVisible = true;
      // this.upbtnVisible = true;
      this.$refs.pFormDataEdit.clearValidate();
      this.pFormData = { ...info, name: info.pname };
    },
    submitEditProject () {
      this.$refs.pFormDataEdit.validate(valid => {
        if (!valid) return false;
              let param = {
        pid: this.pFormData.pid,
        name: this.pFormData.name,
        remark: this.pFormData.remark,
        itemType: 5,
      };
      this.$request.postMicroserDess("/dgm/api/auth/web/itemseybond/updateItemForDIS", param).then(res => {
        if (res.code == 0) {
          this.formEdit = {};
          // 通知项目列表更新(watcher统一刷新，不再直接调用getProjectList避免重复请求)
          this.$store.state.event.updateProjectList = true;
          this.editProjectVisible = false;
          this.editProjectSucVisible = true;
        }else{
          this.deviceTipMsg = res.message||res.errorMessage;
          this.editProjectFailVisible = true;
        }
      });
    });
    },
    // 删除项目
    delProject (info) {
      this.deletingProjectInfo = info;
      this.$store.commit("saveIsShow",1)
    },
    submitDelProject () {
      this.$request.postMicroserDess("/dgm/api/auth/web/itemseybond/delItemForDIS", {pid:this.deletingProjectInfo.pid}).then(res => {
        if (res.code == 0) {
          this.deletingProjectInfo = null;
          this.deviceTipMsg = this.$t("device.deleteSuc");
          this.delProjectSucVisible = true;
          // 通知项目列表更新(watcher统一刷新，不再直接调用getProjectList避免重复请求)
          this.$store.state.event.updateProjectList = true;
        }else{
          this.deviceTipMsg = res.message||res.errorMessage;
          this.delProjectFailVisible = true;
        }
      });
    },
    // // 上传图片
    // uploadImage (event) {
    //   let file = event.target.files[0];
    //   if (file.size > 1 * 1024 * 1024) {
    //     this.$message.error(this.$t("createPlant.fileExceed"));
    //     return;
    //   }

    //   // [增]图片上传进度提示
    //   // console.log("moni-file", file);
    //   // this.upbtnVisible = false;
    //   // this.$set(this.pFormData, 'picSmall', res.dat.picSmall);

    //   // 真实
    //   this.$request.uploadImage(file).then(res => {
    //     if (res.err === 0) {
    //       this.$message.success(this.$t("createPlant.uploadSuccess"));
    //       this.upbtnVisible = false;
    //       // this.pFormData.picSmall = res.dat.picSmall;
    //       this.$set(this.pFormData, "picSmall", res.dat.picSmall);
    //       let defaultsBaseURL = config.env == "production" ? document.location.protocol + '//img.shinemonitor.com/' : document.location.protocol + '//solar.test.eybond.com/'
    //       this.$set(this.pFormData, "picProjectPic", res.dat.picSmall.includes('http')?res.dat.picSmall:defaultsBaseURL +res.dat.picSmall);
    //       // this.$nextTick(() => {
    //       //   this.upbtnVisible = true;
    //       //   // this.pFormData.picSmall = "";
    //       //   this.$set(this.pFormData, 'picSmall', '');
    //       // });
    //       // this.$emit("update:picSmall", res.dat.picSmall)
    //     }
    //   });
    // },
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.search.status = "";
      this.search.pn = "";
      // this.search.brand = "";
      // this.search.search = "";
      this.getDeviceList();
    },
    // 导出报表
    exportPlant (exportPlantParams) {
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    showSearchBtn () {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 关闭批量操作弹条
    closeBatch () {
      this.$refs.multipleSnTable.clearSelection();
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../assets/css/mixin.less");

.project {
  .instructieClass{
    display: flex;
    max-width: 300px;
  }
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px;
  background: rgb(45, 63, 75);
  overflow: auto;

  .p-bottom {
    width: 100%;
    height: 20px;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }
  .elbtn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    line-height:normal
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .p-header {
    background: transparent;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;

    .p-line {
      color: rgba(255, 255, 255, 0.5);
      width: 1px;
      margin: 0px 20px;
    }

    .p-label {
      display: inline-block;
      padding: 5px 0px 5px 0px;
      // color: rgba(255, 255, 255, 0.7);
      color: #EBEBEB;
      font-weight: bold;
      font-size: 22px;
    }

    .backbtn {
      // padding-right: 15px;
      // color: rgba(235, 235, 235, 1);
      color: #EBEBEB;
      font-size: 20px;
      cursor: pointer;

      i {
        margin-right: 10px;
        font-size: 18px;
      }

      // &:hover {
      //   color: @primaryTextColor;
      // }
      &:active {
        color: @primaryTextColor;
      }
    }
  }

  .p-main {
    display: flex;
    justify-content: space-between;
    background: rgb(34, 45, 53);
    height: calc(100% - 50px);

    .p-sidebar {
      // width: 100%;
      min-width: 246px;
      width: 246px;
      max-width: 246px;
      padding: 20px 20px;
      box-shadow: -1px 0px rgba(17, 104, 99, 1) inset;
      overflow-y: scroll;

      .p-name {
        // width: 206px;
        width: 100%;
        max-width: 100%;
        height: 50px;
        border-radius: 6px;
        background: transparent;
        color: rgb(226, 227, 227);
        font-size: 16px;
        margin-bottom: 20px;
        cursor: pointer;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        &.activePro {
          color: @primaryTextColor;
          background: rgba(43, 56, 66, 1);
        }

        .pnamebox {
          // display: block;
          // text-align: left;
          width: 50%;
          margin-right: 5px;
          padding-top: 5px;

          .pname {
            display: inline-block;
            width: 100%;
            font-family: Microsoft YaHei;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }

        // 项目操作
        .p-operatebox {
          display: none;
          max-width: 100%;

          .p-operate {
            position: absolute;
            top: 0px;
            right: 0px;
            // width: 79px;
            height: 50px;
            border-radius: 6px;
            background: rgba(34, 45, 53, 1);
            padding: 16px 18px;
            display: flex;
            align-items: center;
            border: 1px solid #2b3842;

            .ico-edit {
              background: url(../assets/img/general/Icon_Pencil_Dark.png);
            }

            .ico-del {
              background: url(../assets/img/general/Icon_Del_Dark.png);
            }

            .ico {
              display: inline-block;
              width: 16px;
              height: 16px;
              background-repeat: no-repeat;
              background-size: 16px 16px;
              background-position: center;
            }
          }
        }

        &:hover {
          background: rgba(43, 56, 66, 1);

          .p-operatebox {
            display: block;
          }
        }
      }

      // 默认项目
      .p-name-default {
        color: @primaryTextColor;
      }

      .p-name-sign {
        display: inline-block;
        position: absolute;
        top: 0px;
        right: 0px;
        width: 41px;
        height: 40px;
        background: url(../assets/img/general/Icon_Project_Default.png);
        background-repeat: no-repeat;
        background-size: 41px 40px;
        background-position: center;
      }

      .p-name-text {
        display: inline-block;
        width: 100%;
        padding-left: 5px;
        padding-bottom: 8px;
        font-size: 12px;
        transform: rotate(45deg) scale(0.8);
        text-align: center;
      }

      .p-create {
        // width: 200px;
        width: 100%;
        height: 50px;
        border-radius: 6px;
        border: 1px dashed rgba(226, 227, 227, 0.3);
        background: rgba(34, 45, 53, 1);
        color: rgba(226, 227, 227, 1);
        font-size: 16px;
        cursor: pointer;
        margin-bottom: 30px;

        .ico-create {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../assets/img/general/Icon_Project_Add.png);
          background-repeat: no-repeat;
          background-size: 24px 24px;
          background-position: center;
          vertical-align: middle;
          margin-right: 8px;
        }
      }
    }

    .p-panel {
      width: calc(100% - 246px);;
      .debugInfo{
        display: flex;
        flex: 1;
        flex-direction: column;
        background: #2a404a;
        .deviceHeader{
          display: flex;
          font-size: 20px;
          color: #ffffff;
          justify-content: space-between;
          align-items: center;
          background-color: #222d35;
          .deviceHeaderLeft{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            div:last-child{
              padding-left: 35px;
              font-weight: 700;
            }
            .closepage {
              display: inline-block;
              background-color: #23323D;
              width: 60px;
              height:56px;
              background-image: url('../assets/img/general/arrow_left.png');
              background-size: 24px 24px;
              background-repeat: no-repeat;
              background-position: center;
              cursor: pointer;
            }
          }
        }
        .deviceBody{
          height: 100%;
          background-color: #222d35;
          margin-top: 10px;
          padding:20px 500px 20px 110px ;
          color: #fff;
          .devaddrClass{
            width: 200px;
          }
          /deep/.el-form-item__label{
            color: #fff;
            height: 100%;
          }
          /deep/.el-input__inner{
            border-color: rgba(204, 206, 221, 0.5);;
            background: #2b3842;
            color: #fff;
          }
          /deep/.el-textarea__inner {
            border-color: rgba(204, 206, 221, 0.5);;
            background: rgba(43, 56, 66, 1);
            color: #fff;
          }
          // 统一按钮
          .btn {
            padding: 6px 12px;
            border-radius: 6px;
            font-size: 14px;
            cursor: pointer;
          }
          .btn-dark {
            background: @primaryTextColor;
            color: rgba(34, 45, 53, 1);
            border: none;
          }
          // 设备调试返回值
          .debug-return {
            border: 1px solid rgba(204, 206, 221, 0.5);
            border-radius: 4px;
            padding: 0 8px 5px;
            background: rgba(43, 56, 66, 1);
            /deep/.el-textarea__inner {
              border: none;
              background: rgba(43, 56, 66, 1);
              color: #fff;
            }
            /deep/ 
            .return-tool {
              border-bottom: 1px dashed rgba(204, 206, 221, 0.5);
              text-align: right;
              .btn:hover {
                color: @primaryTextColor;
                .ico-clear {
                  background: url(../assets/img/general/Icon_Debug_Delete_Dark.png);
                }
                .ico-copy {
                  background: url(../assets/img/general/Icon_Debug_Copy_Dark.png);
                }
              }
              .btn {
                padding: 0px;
                color: rgba(235, 235, 235, 1);
                font-size: 12px;
                cursor: pointer;
              }
              .ico-clear {
                background: url(../assets/img/general/Icon_Debug_Delete.png);
              }
              .ico-copy {
                background: url(../assets/img/general/Icon_Debug_Copy.png);
              }
              .ico {
                display: inline-block;
                width: 16px;
                height: 16px;
                background-repeat: no-repeat;
                background-size: 100%;
                background-position: center;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .dataloggerListData{
        display: flex;
        flex-direction: column;
        flex: 1;
      }
      .section {
        
        display: flex;
        flex: 1;
        height: 100%;
        padding: 0px;
        flex-direction: column;
        border-radius: 0px;
        border: none;
        background: rgb(34, 45, 53);
        position: relative;
        box-shadow: none;
        overflow: hidden;

        /deep/.el-icon-loading {
          font-size: 28px;
        }

        .search {
          margin: 0px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgb(34, 45, 53);

          .search-label {
            display: inline-block;
            color: #ffffff;
            font-weight: bold;
            line-height: 48px;
            font-size: 14px;
            padding-left: 16px;
          }

          .el-select {
            width: 100px;
            border-right: 1px solid #738089;
          }

          /deep/.el-select:hover {
            background: @primaryColorTransparency30;
          }

          /deep/.el-input {
            width: 100%;
            text-align: center;
          }

          /deep/.el-input__inner {
            background: transparent;
            border: none;
            height: 48px;
            line-height: 48px;
            color: #ffffff;
            padding: 0 16px;
          }

          /deep/.el-input__suffix {
            right: 0px;
          }

          .button {
            height: 48px;
            line-height: 48px;
            padding: 0 25px;
            margin-top: 0px;
            color: @primaryTextColor;
            background: transparent;
            border: none;
          }

          .search-alert {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 48px;
            z-index: 1;
            background: rgb(34, 45, 53);
            display: flex;
            align-items: center;
            justify-content: space-between;

            .search-hide {
              display: inline-block;
              // position: absolute;
              // right: -58px;
              line-height: 48px;
              padding: 0 15px;
              font-size: 14px;
              background: #202d35;
              color: #7b8395;
              border-left: 1px solid #7b8395;
              cursor: pointer;

              &:hover {
                background: @primaryColorTransparency30;
                color: rgb(255, 255, 255, 1);
              }
            }

            /deep/.el-input {
              flex: 1;
            }

            /deep/.el-input .el-input__clear {
              width: 48px;
              color: #7b8395;
            }

            /deep/.el-input .el-input__clear:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }

            /deep/.el-input .el-input__inner,
            /deep/.el-input .el-input__inner:hover {
              height: 48px;
              border-radius: 0px;
              border: none;
              background: #202d35;
              color: #ffffff;
              padding-left: 40px;
            }

            /deep/.el-input__prefix {
              left: 0px;
            }

            /deep/.el-input__icon {
              width: 40px;
            }

            /deep/.el-input__suffix {
              right: 0px;
            }

            /deep/.el-input__suffix:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }

            /deep/.el-icon-circle-close:before {
              content: "X";
            }

            /deep/.el-input:not(:last-child) {
              margin-right: 0px;
            }
          }
        }

        .tableloding {

          // 加载数据时遮罩
          /deep/.el-loading-mask {
            background-color: rgb(34, 45, 53, 0.5);
          }

          /deep/.el-loading-spinner i {
            color: @primaryTextColor;
          }
        }

        .tablemain {
          border: none;
          background-color: rgb(34, 45, 53);

          .operation i {
            color: @primaryTextColor;
          }

          .redirect {
            color: @primaryTextColor;
          }

          /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
            width: 16px;
            height: 16px;
            background: transparent;
            border: 1px solid rgb(180, 184, 193);
            border-radius: 0px;
          }

          /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
            top: 2px;
            left: 5px;
          }

          /deep/.el-table__header th {
            height: 48px;
          }

          /deep/.el-table__header th.is-leaf {
            border-color: rgba(198, 209, 221, 0.5);
            // border-bottom: none;
          }

          /deep/.el-table__header th>.cell {
            font-weight: normal;
            font-size: 12px;
          }

          /deep/.el-table__body tr,
          /deep/.el-table__body td {
            background-color: rgb(34, 45, 53);
            color: #ffffff;
            border-color: rgba(198, 209, 221, 0.5);
          }

          /deep/.el-table__body td.el-table-column--selection {
            background-color: rgb(65, 80, 90);
            color: #ffffff;
          }

          /deep/.el-table__body .cell.el-tooltip {
            font-size: 14px;
          }

          /deep/.el-table__fixed-right::before,
          /deep/.el-table__fixed::before {
            display: none;
          }

          /deep/.el-table--border::after,
          /deep/.el-table--group::after {
            width: 0px;
          }

          ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: #222d35;
            z-index: 9999;
          }

          // 关于复选框
          /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
            background: @primaryTextColor;
            border: 1px solid @primaryTextColor;
          }

          /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background: @primaryTextColor;
            border: 1px solid @primaryTextColor;
          }

          // 关于头部右侧空白
          /deep/.el-table__fixed-right-patch {
            background-color: rgb(65, 80, 90);
            border-bottom: none;
          }

          /deep/th.gutter {
            background-color: rgb(65, 80, 90);
          }

          // 关于右侧操作栏
          // /deep/.el-table__fixed-right .el-table__fixed-body-wrapper{
          //   right:-1px;
          // }
        }

        .tablebottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid rgba(198, 209, 221, 0.5);

          // 分页
          .pagination {
            line-height: 48px;
            height: 48px;
            padding: 0;
            margin: 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 16px;

            /deep/.el-pager li {
              vertical-align: middle;
            }

            /deep/.el-select .el-input {
              width: 90px;
              margin: 0px;
            }

            /deep/.el-input .el-input__inner {
              background-color: #202d35;
              color: #ffffff;
            }

            /deep/.el-input__suffix {
              right: 10px;
            }

            /deep/.el-pagination__sizes {
              margin: 0px;
              height: 48px;
              line-height: 48px;
            }

            /deep/.el-pagination__total {
              color: #fff;
              padding-left: 15px;
              border-left: 1px solid #7b8395;
              height: 48px;
              line-height: 48px;
            }

            /deep/.el-pager li:not(.disabled).active {
              // background: #15C491;
              // color: #ffffff;
              background-color: #2b3842;
              color: #15c491;
            }

            // li:not(.disabled):not(.active):hover
            /deep/.el-pager li:not(.disabled):hover {
              background-color: @primaryColorTransparency30;
              color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pager li {
              background-color: #2b3842;
              color: #7b8395;
            }

            // 页条数下拉
            /deep/.el-select .el-input .el-input__inner {
              border: none;
              height: 48px;
              line-height: 48px;
              border-radius: 0px;
            }

            /deep/.el-select .el-input .el-input__inner:hover {
              background: @primaryColorTransparency30;
            }

            // 跳页
            /deep/.el-pagination__jump {
              color: #ffffff;
            }

            /deep/.el-pagination__editor {
              padding: 0px 6px;
            }

            /deep/.el-pagination__editor.el-input .el-input__inner {
              border: 1px solid #7b8395;
            }
          }

          // 分页前后按钮
          /deep/.el-pagination.is-background .btn-next,
          /deep/.el-pagination.is-background .btn-prev {
            background-color: #2b3842;
            color: #7b8395;
          }

          /deep/.el-pagination.is-background .btn-next:hover,
          /deep/.el-pagination.is-background .btn-prev:hover {
            background-color: @primaryColorTransparency30;
            color: rgba(255, 255, 255, 1);
          }

          /deep/.el-pagination.is-background button[disabled],
          /deep/.el-pagination.is-background button[disabled]:hover {
            background-color: #2b3842;
            color: #7b8395;
          }
        }
      }

      // 右侧面板Tab
      .rightTab {
        // border: 1px solid #cccedd;
        // border-bottom:none;
        height: 100%;
        padding: 0 20px;

        display: flex;
        // flex:1;
        flex-direction: column;
        // margin:10px;
        // // margin: 24px 24px 50px 24px;
        // background-color:#fff;
        // border-radius: 4px;
        // overflow: auto;

        /deep/.el-tabs__nav {
          margin: 0px;
        }

        /deep/.el-tabs__item {
          color: rgba(123, 131, 149, 1);
          height: 60px;
          line-height: 60px;
          // text-align: center;
          padding: 0px 12px;
          // margin-right: 30px;
        }

        /deep/.el-tabs__item.is-active {
          color: rgba(51, 255, 182, 1);
          border-bottom: 3px solid rgba(51, 255, 182, 1);
        }

        /deep/.el-tabs__item:hover {
          background: @primaryColorTransparency30;
          color: rgba(240, 242, 244, 1);
        }

        // 底部长条
        /deep/.el-tabs__nav-wrap::after {
          display: none;
        }

        /deep/.el-tabs__active-bar {
          display: none;
        }

        // /deep/.el-tabs__nav-scroll {
        //   border-bottom: 1px solid rgba(198, 209, 221, 0.5);
        // }
        /deep/.el-tabs__header {
          border-bottom: 1px solid rgba(198, 209, 221, 0.5);
        }
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }

  .el-table--border::after,
  .el-table--group::after {
    width: 0px;
  }

  // 控制弹框
  .control {
    .tableBackgruond{
      background-color: #222d35
    }
    .current-value {
      display: flex;

      .el-input {
        flex: 1;
        margin-right: 3px;
      }

      .submit-control {
        i {
          font-size: 16px;
        }

        padding: 5px 12px;
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: rgba(255, 255, 255, 1);
      }
    }

    .control-value {
      .submit-control {
        i {
          font-size: 18px;
        }
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: @primaryTextColor;
      }
    }

    /deep/.el-input .el-input__inner {
      border: none;
    }

    /deep/.el-table th,
    /deep/.el-table tr {
      background: rgba(34, 45, 53, 1);
      color: #ffffff;
      padding: 0px 10px;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
      border: none;
    }

    // /deep/.el-button,
    // /deep/.el-button:focus,
    // /deep/.el-button:hover {
    // 	background: transparent;
    // 	border: none;
    // 	color: @primaryTextColor;
    // }
    // 表头
    /deep/.el-table th {
      border: none;
      box-shadow: 0px 1px rgba(255, 255, 255, 0.25) inset,
        0px -1px rgba(255, 255, 255, 0.25) inset;
    }

    /deep/.el-table--border,
    /deep/.el-table--group {
      border: none;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    // 间距
    /deep/ .el-table__body {
      border-collapse: separate;
      border-spacing: 10px;
      table-layout: auto !important;
      background: rgba(34, 45, 53, 1);
    }
  }

  .tableloding {

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      // background-color: rgb(34, 45, 53, .5);
      background-color: transparent;
    }

    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor !important;
    }
  }


  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }

  // 上传图片
  // .upload-contents {
  //   border-radius: 6px;
  //   border: 1px dashed rgba(255, 255, 255, 0.5);
  //   padding: 10px;
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   .upload-buttonEquipment {
  //     background: transparent;
  //     border: none;
  //     cursor: pointer;
  //     padding: 6px 16px 6px 10px;
  //     color: rgba(255, 255, 255, 0.5);
  //     font-size: 14px;
  //     i {
  //       color: rgb(56, 165, 118);
  //       font-size: 32px;
  //     }
  //   }
  // }

  // 批量操作弹条
  .batch-alert {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    z-index: 1;
    background: rgba(255, 231, 107, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .batch-total {
      padding-left: 16px;
      font-size: 14px;
    }

    .batch-right {
      display: flex;
      justify-content: flex-end;
    }

    .batch-hide {
      height: 48px;
      line-height: 48px;
      padding: 0px 16px;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: rgba(255, 255, 255, 1);
      }
    }

    .batch-operate {
      display: flex;
      justify-content: flex-end;

      .btn {
        color: rgba(34, 45, 53, 1);
        font-size: 14px;
        cursor: pointer;
        // display: inline-block;
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        border-radius: 0px;
        display: flex;
        align-items: center;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .ico-copy {
        background: url(../assets/img/general/Icon_Batch_Copy.png);
      }

      .ico-export {
        background: url(../assets/img/general/Icon_Batch_Export.png);
      }

      .ico-clear {
        background: url(../assets/img/general/Icon_Batch_Delete.png);
      }

      .ico-more {
        background: url(../assets/img/general/Icon_Batch_More.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 8px;
      }

      // 批量更多下拉 (不可scoped)(.dropdown-more)
    }
  }
}

// Loading
// .el-loading-spinner .path {
//   stroke: @primaryTextColor!important;
// }

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}

// 固件升级状态窗
.upgradeNew {
  /deep/.el-radio__input.is-checked .el-radio__inner{
    background: #15C491;
    background-color: #15C491;
    border-color:#15C491;
  }
  /deep/.el-radio__input.is-checked+.el-radio__label{
    color: #15C491;
  }
  .processstatue,
  .processstatueEquipment {
    font-size: 16px;
    color: #16D09A;
  }
  .processstatue,
  .processstatueEquipment1 {
    font-size: 16px;
    color: #ff3e3e;
  }

  /deep/.el-progress__text {
    color: #ffffff;
  }

  .progerssComplete,
  .progerssCompleteEquipment {
    background: transparent;
  }

  // 升级完成显示已完成的设备列表
  .progerssCompleteEquipment {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0px;
    align-items: flex-start;

    .progressName {
      margin-left: 0px;
    }
  }
      // 遮罩
      /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    // 花形
    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    // 环形
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
    /deep/.el-icon-loading {
        font-size: 28px;
    }
}
</style>
<style lang="less">
// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}

.project {

  .el-popper .popper__arrow,
  .el-popper .popper__arrow::after {
    display: none;
  }
}

// #下拉选框 el-select#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

// 控制项日期选择样式
.select-date .el-input .el-input__inner,
.select-date .el-picker-panel__footer {
  background: #222d35
}

.select-date .el-button {
  background: #222d35;
  color: @primaryTextColor;

  &:hover {
    background: #222d35;
    color: @primaryTextColor;
  }
}

.el-table--border::after,
.el-table--group::after {
  display: none;
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  // font-weight: 100;
  font-family: Microsoft YaHei;
}
</style>